import React from "react";
import "./index.less";
import PopupBottomModal from "../popup-bottom-modal";
import { Toast } from "@xp-design/mobile";

interface SharePosterPanelPropsRule {
  posterUrl: string;
  visible: boolean;
  onClose?: () => void;
}

const SharePosterPanel = (props: SharePosterPanelPropsRule) => {
  const { posterUrl, visible, onClose = () => {} } = props;

  const saveToPhone = () => {
    Toast.show("长按图片进行保存");
  };

  return (
    <>
      {visible && <img src={posterUrl} alt="" className="poster" />}
      <PopupBottomModal visible={visible} title="" onClose={onClose}>
        <div className="share-poster-panel">
          <div className="save-to-phone" onClick={saveToPhone}>
            保存到手机
          </div>
          <div className="cancel" onClick={onClose}>
            取消
          </div>
        </div>
      </PopupBottomModal>
    </>
  );
};

export default SharePosterPanel;
